import React from 'react';
import { SocketService } from './socketService';

export const SocketContext = React.createContext(new SocketService());